import { decryptDataFromArray } from "./EncDec";

// check token
const isTokenExpired = () => {
  const token = localStorage.getItem("auth_token");

  if (token) {
    return true;
  }

  return false;
};

//is user is logged in
export const isAuthenticated = () => {
  if (isTokenExpired() === true && getUserInfo() !== null) {
    return true;
  }

  return false;
};

// user info
export const getUserInfo = () => {
  const user = localStorage.getItem("user_info");

  if (!user || user === "undefined" || user === "null") {
    return null;
  }

  try {
    return JSON.parse(user);
  } catch (error) {
    console.error("Invalid user_info in localStorage:", error);
    return null;
  }
};


// save user token
export const getUserToken = () => {
  const raw = localStorage.getItem("authUser");
  if (!raw || raw === "null" || raw === "undefined") return null;
  const accessToken = JSON.parse(raw)?.accessToken;
  if (!accessToken) return null;
  return "Bearer " + accessToken;
};

export const getClientCredentials = () => {
  let clientCredentials = localStorage.getItem("client_company");

  if (!clientCredentials) {
    return null;
  }

  clientCredentials = JSON.parse(clientCredentials);
  clientCredentials = decryptDataFromArray(clientCredentials);

  return clientCredentials;
};
